import React from 'react';
import { RadioGroup } from '@one-thd/sui-atomic-components';
import { RETURN_METHOD } from '@src/constants/general';
import { useReturnStore } from '@src/stores/returnStore';
import { InStoreReturnMethodDescription, ReturnMethodOption, } from './ReturnMethodHelper';
import { ReturnButtons } from '../shared/ReturnButtons';
var SingleInStoreOption = function (_a) {
    var handleContinueButton = _a.handleContinueButton, handleMethodChange = _a.handleMethodChange, hostname = _a.hostname;
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var returnMethod = useReturnStore(function (state) { return state.returnMethod; });
    return (React.createElement(React.Fragment, null,
        React.createElement(RadioGroup, { value: returnMethod },
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(ReturnMethodOption, { returnMethodName: RETURN_METHOD.IN_STORE, returnMethodHeader: "In-Store Drop-Off", returnMethodDescription: InStoreReturnMethodDescription(hostname, isMilitaryExchangeGuest), onChange: handleMethodChange }))),
        React.createElement(ReturnButtons, { proceedNext: handleContinueButton })));
};
export default SingleInStoreOption;
